import React from 'react';
import Link from './Link';
import styled from 'styled-components';

import breakpoints from '../styles/breakpoints';
import {
  tagIcon,
  qualityIcon,
  deliveryIcon,
  packageIcon
} from '../media/icons';

import Section, { Content } from './Section';

const StyledShortCutIconGridSection = styled(Section)`
  background-color: ${p => p.theme.colors.lightBg};
  padding: 47px 20px;

  ${breakpoints.medium`
    padding: 79px 20px;
  `};

  ${breakpoints.large`
    padding: 140px 20px;
  `};
`;

const Grid = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const Item = styled.div`
  flex: 0 0 100%;
  padding: 0 5px 10px;
  ${breakpoints.medium`
    flex: 0 0 50%;
    max-width: 50%;
  `};
`;

const StyledLink = styled(Link)`
  background-color: ${p => p.theme.colors.bg};
  color: ${p => p.theme.colors.lightFont};
  display: flex;
  text-decoration: none;
  padding: 19px 16px;
  transition: 1s background-color, 0.4s color;

  ${breakpoints.medium`
	padding: 30px 17px;
  `};

  ${breakpoints.large`
    padding: 38px 20px;
  `};

  &:hover > div {
    color: ${p => p.theme.colors.lightFont};
  }
`;

const Icon = styled.img`
  height: 33px;
  width: 33px;
  margin-right: 14px;
`;

const Text = styled.p`
  font-size: 1.25rem;
  font-weight: 500;
  margin: 0;
`;

export default function ShortCutIconGridSection() {
  return (
    <StyledShortCutIconGridSection>
      <Content small>
        <Grid>
		  <Item>
          	<StyledLink to="/informasjon/">
              <Icon src={tagIcon} /> <Text>Lave priser</Text>
			</StyledLink>
          </Item>

		  <Item>
            <StyledLink to="/informasjon/">
              <Icon src={qualityIcon} /> <Text>Høy kvalitet</Text>
            </StyledLink>
		  </Item>

          <Item>
		    <StyledLink to="/informasjon/">
              <Icon src={deliveryIcon} /> <Text>Rask levering</Text>
			</StyledLink>
          </Item>

          <Item>
		    <StyledLink to="/informasjon/">
              <Icon src={packageIcon} /> <Text>Trygg handel</Text>
			</StyledLink>
          </Item>
        </Grid>
      </Content>
    </StyledShortCutIconGridSection>
  );
}
